module.exports = __webpack_public_path__ + "img/sld_down_arrow.904539dc.svg";